'use client';

import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { ErrorBoundary, LegacyIcon, LegacyIconName } from '@libs/common-next';
import { Loading, LoggedIn, SignIn } from './components';
import { useAccountDropdown } from './use-account-dropdown';
import './LegacyAccountDropdown.scss';
export function LegacyAccountDropdown() {
  const $ = _c(8);
  const {
    isLoading,
    isLoggedIn
  } = useAccountDropdown();
  let t0;
  if ($[0] !== isLoading || $[1] !== isLoggedIn) {
    t0 = isLoading ? <><div className="legacy-account__title"><Loading /></div><TextPassage className="legacy-account__sub">{"Rewards & Account"}</TextPassage></> : isLoggedIn ? <><div className="legacy-account__title"><LoggedIn /></div><TextPassage className="legacy-account__sub">{"Rewards & Account"}</TextPassage></> : <><div className="legacy-account__title"><ErrorBoundary><SignIn /></ErrorBoundary></div><TextPassage className="legacy-account__sub">{"Rewards & Account"}</TextPassage></>;
    $[0] = isLoading;
    $[1] = isLoggedIn;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const accountAction = t0;
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("legacy-account");
    t2 = cn("legacy-account__inner");
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="legacy-account__icon-box"><LegacyIcon isPriority={true} size={45} className="icon" name={LegacyIconName.TREATS_NEW_LG} /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== accountAction) {
    t4 = <div className={t1}><div className={t2}>{t3}<div className="legacy-account__action">{accountAction}</div></div></div>;
    $[6] = accountAction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}